import { useState } from "react";
import { NumberInput, type NumberInputProps } from "@mantine/core";
import { formatPaise } from "../lib/format";
import { CTC_MAX_LAKHS, ctcLakhsLiveError, lakhsToPaise } from "../lib/ctcLakhs";

type Props = Omit<NumberInputProps, "min" | "max" | "decimalScale" | "clampBehavior"> & {
  extraDescription?: string;
};

export function CtcLakhsInput({
  extraDescription,
  value,
  description,
  error,
  onChange,
  ...rest
}: Props) {
  const [liveError, setLiveError] = useState<string | null>(null);
  const n = typeof value === "number" ? value : Number(value);
  const showPreview = Number.isFinite(n) && n > 0 && n <= CTC_MAX_LAKHS;
  const preview = showPreview ? formatPaise(lakhsToPaise(n)) : null;
  const hint = ["e.g. 8.5 for ₹8.5 LPA", preview ? `= ${preview} / year` : null, extraDescription]
    .filter(Boolean)
    .join(" · ");

  return (
    <NumberInput
      min={0}
      max={CTC_MAX_LAKHS}
      decimalScale={2}
      clampBehavior="none"
      hideControls
      {...rest}
      value={value}
      error={error ?? liveError}
      description={description ?? hint}
      onChange={(next) => {
        const msg = ctcLakhsLiveError(next);
        if (msg) {
          setLiveError(msg);
          return;
        }
        setLiveError(null);
        onChange?.(next);
      }}
    />
  );
}
